module.exports = __webpack_public_path__ + "static/media/logo_header_template_letter.818f37f8.jpg";